import { render, staticRenderFns } from "./AccountTypeDetails.vue?vue&type=template&id=770731e3"
import script from "./AccountTypeDetails.vue?vue&type=script&lang=js"
export * from "./AccountTypeDetails.vue?vue&type=script&lang=js"
import style0 from "./AccountTypeDetails.vue?vue&type=style&index=0&id=770731e3&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports